import { FC, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios, { AxiosResponse } from "axios";
import ReactNotification from "react-notifications-component";
import CancelIcon from "@material-ui/icons/Cancel";

import { base_url } from "../../../utils/env";
import {
  Notification,
  DANGER,
  ERROR,
  APP_SELECT_ERROR
} from "../../../utils/ReactNotification.config";
import {
  BOOK_IT,
  BOOK_IT_PATTERN,
  SUCCESSWARE_PAY,
  SUCCESSWARE_PAY_PATTERN
} from "./home.const";
import Header from "../../sections/Header";
import Breadcrumbs from "../../UI/Breadcrumbs";
import CardAction from "../../UI/CardAction";
import Loader from "../../UI/CustomLoader";

import "../../css/home.css";

import GoogleAnalyticsConfiguration from "../../../googleAnalytics/googleAnalyticsConfiguration";

const Home: FC = () => {

    const [selectApps, setSelectApps] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const breadcrumbs = [
        {
            redirect: "",
            title: "Home",
        }
    ];

    useEffect(() => {
        const token: string = "Bearer ".concat(localStorage.getItem("token") as string);
        GoogleAnalyticsConfiguration.sendPageView("Landing");
        axios.defaults.headers.common['Auth'] = token;
        localStorage.removeItem("swpayCompanySelected");
        setLoading(true);
        axios.get(`${base_url}api/swapi/abilities/list`)
            .then((response: AxiosResponse<any>) => {
                setSelectApps(response.data.agentsEnabled);
                setLoading(false);
            })
            .catch(() => {
                setSelectApps([]);
                setLoading(false);
            });
    }, [])

    const OnCardClick = (app: string) => {
        if (app === BOOK_IT)
            history.push("/admin/widget/");
        else if (app === SUCCESSWARE_PAY)
            history.push("/admin/successwarepay/");
        else
            Notification.showNotification(ERROR, APP_SELECT_ERROR, DANGER);
    }

    const checkSelectApps = (app: string) => {
        if (app === SUCCESSWARE_PAY) {
            return selectApps.some((value: string) => SUCCESSWARE_PAY_PATTERN.test(value));
        }
        else if (app === BOOK_IT) {
            return selectApps.some((value: string) => BOOK_IT_PATTERN.test(value));
        }
        else return false;
    }

    return (
        <>
            <ReactNotification />
            <Header />
            <Breadcrumbs details={breadcrumbs} />
            <Loader showLoader={loading} />
            <div className="home-container">
                {selectApps.length !== 0 && !loading &&
                    <div>
                        <h1 className="custom-title-home">
                            How can we help you?
                        </h1>
                        <p className="dashboard-title text-xl m-3 text-center ">
                            Choose which option is the best for you
                        </p>
                        <div className="cards-container">
                            {checkSelectApps(BOOK_IT) &&
                                <CardAction title="BookIt"
                                    clickAction={
                                        () => OnCardClick(BOOK_IT)
                                    } />
                            }
                            {checkSelectApps(SUCCESSWARE_PAY) &&
                                <CardAction title="Successware Pay"
                                    clickAction={
                                        () => OnCardClick(SUCCESSWARE_PAY)
                                    } />
                            }
                        </div>
                    </div>
                }
                {selectApps.length === 0 && !loading &&
                    <div className="error-container">
                        <CancelIcon htmlColor="#ea354e" fontSize="large" />
                        <h1 className="dashboard-title text-xl m-1 text-center">
                            System Error occurred.
                        </h1>
                        <h1 className="dashboard-title text-xl m-1 text-center">
                            Please try again later.
                        </h1>
                    </div>
                }
            </div>
        </>
    );
};

export default Home;
